// Module
var code = "<div class=\"text-center\" style=\"padding:1em\"> <div id=\"loading\" class=\"spinner-border\" role=\"status\"> <span class=\"visually-hidden\">Loading...</span> </div> </div>";
// Exports
module.exports = code;